function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoKavakWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 550 144.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logoA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M101.17,120.81,75.89,72.43,113.74,0H79.91L41.44,72.43l38.47,72.44h42l11.79-22.56H177L164.34,98.15H146.23l18-34.48,42.43,81.2h33.26L164.3,0ZM0,144.87H30.78V0H0Zm436.26-24.21L373.25,0,297.52,144.87h33.3l42.43-81.2,18,34.48h-18l-12.62,24.14h43.25l11.79,22.58h51.4V0H436.26ZM311.18,0,268.75,81.2,226.33,0H193.06l75.69,144.87L344.45,0ZM550,0H516.22L477.74,72.43l38.48,72.44H550L512.15,72.43Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKavakWhite);
export default __webpack_public_path__ + "static/media/logo_kavak_white.c8bcab8d648221b8c2163b5d8424e958.svg";
export { ForwardRef as ReactComponent };